import React from 'react';
import { Link } from 'react-router-dom';
import Close from 'material-ui/svg-icons/navigation/close';
import Dialog from 'material-ui/Dialog';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import { m } from '../../utils';
import './alert.css';

const BookDialog = ({ closeDialog, dialogMessages = [], isDialogOpen }) => (
  <Dialog
    actions={
      <div className="buttons-div">
        <Link to="/dashboard">
          <button type="button" className="alert-button" onClick={closeDialog}>
            BACK TO DASHBOARD
          </button>
        </Link>

        <Link to="/book">
          <button
            type="button"
            className="alert-button"
            onClick={() => {
              // window.location.reload();
              closeDialog();
            }}>
            CONTINUE BOOKING
          </button>
        </Link>
      </div>
    }
    open={isDialogOpen}
    paperProps={{ style: { borderRadius: '4px' } }}>
    {dialogMessages.bookings.length ? (
      <p style={{ textAlign: 'center' }}>
        {`You've successfully booked
        ${dialogMessages.bookings.length > 1 ? `${dialogMessages.bookings.length} shifts!` : ' a shift!'} `}{' '}
        Car details and access code will be available 10 minutes prior to your booking start time.
      </p>
    ) : null}
    {dialogMessages.errors.length ? (
      <List>
        {dialogMessages.errors.map(error => (
          <List key={error.message}>
            <Subheader color="red">
              {`A few things went wrong with your shift from ${m(error.startTime).format('h:mm a')} to ${m(
                error.endTime
              ).format('h:mm a')}`}
            </Subheader>
            {m().isBefore('2018-11-04 02:00-04:00') ? (
              <ListItem
                key={error.message}
                leftIcon={<Close color="red" />}
                secondaryText={
                  <p>
                    If you encounter any errors booking shifts for Nov 4 onwards, please call{' '}
                    <a href="tel:+18336928898">+1-833-692-8898</a>
                  </p>
                }
              />
            ) : (
              <ListItem key={error.message} leftIcon={<Close color="red" />} secondaryText={error.message} />
            )}
          </List>
        ))}
      </List>
    ) : null}
  </Dialog>
);

export default BookDialog;



// WEBPACK FOOTER //
// ./src/components/Alert/BookDialog.js